import classNames from 'classnames';
import React, { useReducer } from 'react';
import { useTranslation } from 'react-i18next';
import InputMask from 'react-input-mask';
import { InputProps } from '../../../common/components/form-elements/Input';
import bannerBMW from '../../assets/images/banner/manutencoes_bmw_1_1080.jpg';
import bannerMINI from '../../assets/images/banner/manutencoes_mini_1_1080.jpg';
import { config } from '../../common/';
import Header from '../../main/components/Header';
import css from './Packages.scss';
import PackServiceInclusive from './PackServiceInclusive';
import PackValueService from './PackValueService';

interface PackagesLayoutContainerProps {
    licensePlate: InputProps;
    vin: InputProps;
}
interface PackagesLayoutState {
    licensePlate: string;
    vin: string;
    licensePlateValMsg: string;
    vinValMsg: string;
    vehcode: number;
    tab: number;
}

const PackagesLayout: React.FC = (Props) => {
    const initialState: PackagesLayoutState = {
        licensePlate: '',
        vin: '',
        licensePlateValMsg: '',
        vinValMsg: '',
        vehcode: -1,
        tab: 1,
    };
    const [state, setState]: [PackagesLayoutState, React.Dispatch<any>] = useReducer(
        (oldState, newState) => ({ ...oldState, ...newState }), initialState,
    );
    const { t } = useTranslation();

    const changeTab = (tabIdx: number) => {
        if (state.tab !== tabIdx) {
            setState({ tab: tabIdx });
        }
    };

    const onLicencePlateChange = (event: React.FormEvent<HTMLInputElement>) => {
        setState({ licensePlate: event.currentTarget.value });
        if (event.currentTarget.value !== '') {
            setState({ licensePlateValMsg: '', vinValMsg: '' });
        } else {
            if (state.vin === '') {
                setState({ licensePlateValMsg: t('packages:mandatory') });
            }
        }
        if (event.currentTarget.value.length === 8 || state.vin.length === 17) {
            setState({ vehcode: 1 });
        } else { setState({ vehcode: -1 }); }
    };

    const onVinChange = (event: React.FormEvent<HTMLInputElement>) => {
        setState({ vin: event.currentTarget.value });
        if (event.currentTarget.value !== '') {
            setState({ licensePlateValMsg: '', vinValMsg: '' });
        } else {
            if (state.licensePlate === '') {
                setState({ vinValMsg: t('packages:mandatory') });
            }
        }
        if (event.currentTarget.value.length === 17 || state.licensePlate.length === 8) {
            setState({ vehcode: 1 });
        } else { setState({ vehcode: -1 }); }
    };

    const newProps: PackagesLayoutContainerProps = {
        licensePlate: {
            inputProps: {
                value: state.licensePlate,
                onChange: onLicencePlateChange,
            },
            errorText: state.licensePlateValMsg,
            hintText: '',
        },
        vin: {
            inputProps: {
                value: state.vin,
                onChange: onVinChange,
            },
            errorText: state.vinValMsg,
            hintText: '',
        },
    };

    return (
        <div className={classNames(['grid-container', 'padding-bottom-4', 'value-service'])}>
            <div className={classNames(['grid-x', 'grid-margin-x'])}>
                <Header title={t('packages:baseHeader')} />
                <div className={classNames(['cell', 'large-10', 'large-offset-1', 'columns', 'my-bmw-pacotes'])}>
                    <img src={config.BrandEnv === 'BMW' ? bannerBMW : bannerMINI} />
                    <div className={css.topMargin}>
                        <div className={classNames(['grid-x', 'grid-margin-x'])}>
                            <div className={classNames(['cell', 'medium-6', 'small-12'])}>
                                <label className={classNames(['form-label', 'distritosReparadores'])}>
                                    {t('signup:formFields.licensePlate')}*
                                    <React.Fragment>
                                        <InputMask type="text" className={css.border} {...newProps.licensePlate.inputProps} maskChar="" mask="**-**-**" />
                                        <div className="error-message">{newProps.licensePlate.errorText}</div>
                                    </React.Fragment>
                                </label>
                            </div>
                            <div className={classNames(['cell', 'medium-6', 'small-12'])}>
                                <label className={classNames(['form-label', 'distritosReparadores'])}>
                                    {t('signup:formFields.vin')}*
                                    <InputMask className={css.border} {...newProps.vin.inputProps} maskChar="" mask="*****************" type="text" />
                                    <div className="error-message">{newProps.vin.errorText}</div>
                                </label>
                            </div>
                         </div>
                         <label className={css.mandatoryMessage}>{t('packages:mandatoryMessage')}</label>
                    </div>
                    <ul className={'tabs'} data-active-collapse="true" id="collapsing-tabs">
                        <li className={classNames(['tabs-title', { 'is-active': state.tab === 1 }])}>
                            <a onClick={() => changeTab(1)} className={classNames([{ 'text-bold': state.tab === 1 }])}>
                                {t('packages:valueService')}
                            </a>
                        </li>
                        <li className={classNames(['tabs-title', { 'is-active': state.tab === 2 }])}>
                            <a onClick={() => changeTab(2)} className={classNames([{ 'text-bold': state.tab === 2 }])}>
                                {t('packages:serviceInclusive')}
                            </a>
                        </li>
                    </ul>
                    {state.tab === 1 && <PackValueService vehcode={state.vehcode} vin={state.vin} licensePlate={state.licensePlate} />}
                    {state.tab === 2 && <PackServiceInclusive vehcode={state.vehcode} vin={state.vin} licensePlate={state.licensePlate} />}
                </div>
            </div>
        </div>
    );
};

export default PackagesLayout;
